module.exports = __webpack_public_path__ + "static/snake-041e029a81c21dd99a86222e82d5c39f.jpg";